import { render, staticRenderFns } from "./BackendLayout.vue?vue&type=template&id=0dd97c18&scoped=true"
import script from "./BackendLayout.vue?vue&type=script&lang=js"
export * from "./BackendLayout.vue?vue&type=script&lang=js"
import style0 from "./BackendLayout.vue?vue&type=style&index=0&id=0dd97c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd97c18",
  null
  
)

export default component.exports